export const useConditionalPlatformRoute = (pathname: string) => {
    return !pathname.includes("ceny") && !pathname.includes("prices");
};
